import React from "react";
import { Truck, CheckCircle, Circle, Clock, FileText } from "lucide-react";

var stages = [
  { id: "selection", label: "Selección", icon: Circle },
  { id: "reservation", label: "Reserva", icon: Circle },
  { id: "purchase", label: "Compra", icon: Circle },
  { id: "transport", label: "Transporte", icon: Truck },
  { id: "documentation", label: "Documentación", icon: FileText },
  { id: "delivery", label: "Entrega", icon: CheckCircle },
];

function ImportPage({ imports, vehicles, clients }) {
  return (
    <div className="h-screen overflow-y-auto p-8 bg-slate-50" data-testid="import-page">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-slate-800">Importaciones</h1>
        <p className="text-slate-500">Seguimiento de vehículos en proceso de importación</p>
      </div>

      {imports.length === 0 ? (
        <div className="bg-white rounded-xl p-12 text-center border">
          <Truck size={48} className="mx-auto text-slate-300 mb-4" />
          <p className="text-slate-500">No hay importaciones en curso</p>
        </div>
      ) : (
        <div className="space-y-6">
          {imports.map(function(imp) {
            var vehicle = vehicles.find(function(v) { return v.id === imp.vehicleId; });
            var client = clients.find(function(c) { return c.id === imp.clientId; });
            
            return (
              <div key={imp.id} className="bg-white rounded-xl border shadow-sm overflow-hidden">
                {/* Header */}
                <div className="p-6 border-b bg-slate-50">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="text-lg font-bold text-slate-800">
                        {vehicle ? vehicle.brand + " " + vehicle.model : "Vehículo #" + imp.vehicleId}
                      </h3>
                      <p className="text-slate-500">Cliente: {client ? client.name : "Sin asignar"}</p>
                    </div>
                    <span className="px-4 py-2 bg-cyan-100 text-cyan-700 rounded-full text-sm font-medium">
                      En {stages.find(function(s) { return s.id === imp.status; })?.label || imp.status}
                    </span>
                  </div>
                </div>

                {/* Timeline */}
                <div className="p-6">
                  <div className="flex items-center justify-between">
                    {stages.map(function(stage, idx) {
                      var timelineItem = imp.timeline.find(function(t) { return t.stage === stage.id; });
                      var isCompleted = timelineItem && timelineItem.completed;
                      var isCurrent = imp.status === stage.id;
                      var Icon = stage.icon;
                      
                      return (
                        <div key={stage.id} className="flex-1 flex items-center">
                          <div className="flex flex-col items-center">
                            <div className={
                              "w-10 h-10 rounded-full flex items-center justify-center " +
                              (isCompleted ? "bg-green-500 text-white" : 
                               isCurrent ? "bg-cyan-500 text-white" : 
                               "bg-slate-200 text-slate-400")
                            }>
                              {isCompleted ? <CheckCircle size={20} /> : <Icon size={20} />}
                            </div>
                            <p className={"text-xs mt-2 font-medium " + (isCompleted || isCurrent ? "text-slate-700" : "text-slate-400")}>
                              {stage.label}
                            </p>
                            {timelineItem && timelineItem.date && (
                              <p className="text-xs text-slate-400">{timelineItem.date}</p>
                            )}
                          </div>
                          {idx < stages.length - 1 && (
                            <div className={"flex-1 h-1 mx-2 " + (isCompleted ? "bg-green-500" : "bg-slate-200")}></div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Notes */}
                {imp.notes && (
                  <div className="px-6 pb-6">
                    <div className="p-4 bg-amber-50 rounded-lg border border-amber-200">
                      <p className="text-sm text-amber-800">{imp.notes}</p>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default ImportPage;
